export const maxWidth = 984;
export const maxTextWidth = 600;
export const mobileAppColor = '#68bb93';
